import Solutions from 'components/solutions/Solutions.jsx'

export default function SolutionsPage(){
  return(
    <Solutions />
  )
}
export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "Solutions",
        description: "Experts since 2004. Let us transform your data landscape with customized, innovative, and agile solutions.",
      },
    },
  };
};